import React from "react";
import CreateModelHeader from "./components/CreateModelHeader";
import CreateModelProgress from "./components/CreateModelProgress";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import FormikControl from "../../components/signUpForm/ReusableFormik/FormikControl";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import Vector from "../../assets/Vector.svg"
import { ModelContext } from "./DataContext";
import { useContext } from "react";

const CreateModelStep3_0 = ()=>{

   const navigate = useNavigate();
   const {saveModelData} = useContext(ModelContext);

   const validationSchema = Yup.object({
        variable1_0: Yup.string().required("Required"),
        variable2_0: Yup.string().required("Required"),
        operator1_0: Yup.string().required("Required"),
        operator2_0: Yup.string().required("Required"),
        value1_0: Yup.number().typeError('Must be a number').required("Required"),
        value2_0: Yup.number().typeError('Must be a number').required("Required"),
        score1_0: Yup.number().typeError('Must be a number').required("Required"),
        score2_0: Yup.number().typeError('Must be a number').required("Required"),
    });

    const initialValues = {
        variable1_0: "",
        variable2_0: "",
        operator1_0: "",
        operator2_0: "",
        value1_0: "",
        value2_0: "",
        score1_0: "",
        score2_0: "",
    } 

const onSubmit = (values) => {
    saveModelData(values)
    navigate("/CreateModelStep3");
};



   const variable1 = [
    { value: '', key: 'Select' },
       { value: 'Monthly average income', key: 'Monthly average income' },
       { value: 'Monthly average expense', key: 'Monthly average expense' },
       { value: 'Total re-occuring expense', key: 'Total re-occuring expense' },
       { value: 'Average debit', key: 'Average debit' },
       { value: 'Average credit', key: 'Average credit' },
       { value: 'Average balance', key: 'Average balance' },
       { value: 'Most frequent balance', key: 'Most frequent balance' },
   ];

   const Operator1 = [
    { value: '', key: 'Select' },
       { value: 'Less than', key: 'Less than' },
       { value: 'Less than or equal to' , key: 'Less than or equal to' },
       { value: 'Greater than', key: 'Greater than' },
       { value: 'Greater than or equal to', key: 'Greater than or equal to' },
       { value: 'Equal to', key: 'Equal to' },
   ];


   return(
       <div>
           <div>
               <CreateModelHeader/>
           </div>
           <div>
               <CreateModelProgress title={'Create Predition Model'} indexActualPage={2}/>
           </div>
           
            {/* <div className="mt-3 xl:flex-row md:flex-row flex justify-center sm:items-center sm:flex-col"> */}

               {/* <div className="flex"> */}
                <div className="flex justify-center"> 
                    {/* className="mt-5 flex flex-col items-center justify-center bg-red-100" */}
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={onSubmit}
                    >
                        {(formik) => {
                            return (
                                <Form className="">  
                                <div className="flex xl:flex-row md:flex-row sm:flex-col sm:items-center xl:justify-center">                             
                                    <div className="flex">
                                        <div className="flex flex-col">
                                            <div className="xl:w-[265px] md:w-[190px] sm:w-[230px] mr-4">
                                                <FormikControl
                                                    control="select"
                                                    label="Variable"
                                                    // type="text"
                                                    name="variable1_0"
                                                    options={variable1}
                                                />
                                            </div>
                                            
                                            <div className="xl:w-[265px] md:w-[190px] sm:w-[230px] mr-4">
                                                <FormikControl
                                                    control="select"
                                                    label=""
                                                    // type="text"
                                                    name="variable2_0"
                                                    options={variable1}
                                                />
                                            </div>
                                            
                                        </div>

                                        <div className="flex flex-col">
                                            <div className="xl:w-[265px] md:w-[190px] sm:w-[230px] mr-4">
                                                <FormikControl
                                                    control="select"
                                                    label="Operator"
                                                    // type="text"
                                                    name="operator1_0"
                                                    options={Operator1}
                                                />
                                            </div>
                                            
                                            <div className="xl:w-[265px] md:w-[190px] sm:w-[230px] mr-4">
                                                <FormikControl
                                                    control="select"
                                                    label=""
                                                    // type="text"
                                                    name="operator2_0"
                                                    options={Operator1}
                                                />
                                            </div>
                                            
                                        </div>
                                    </div>

                                    <div className="flex">
                                        <div className="flex flex-col sm:-ml-4 xl:pl-3 md:pl-2">                                   
                                            <div className="xl:w-[265px] md:w-[190px] sm:w-[230px] mr-4 flex justify-start mt-1">                                                
                                                <img src={Vector} alt="Moeda" className="mr-1 mt-16" />                                                                                                                          
                                                <FormikControl
                                                    control="input"
                                                    label="Value"
                                                    type="text"
                                                    name="value1_0"                                           
                                                />
                                            </div>
                                          
                                            <div className="xl:w-[265px] md:w-[190px] sm:w-[230px] pl-4 mr-4">                                             
                                                <FormikControl
                                                    control="input"
                                                    label=""
                                                    type="text"
                                                    name="value2_0"
                                                 
                                                />
                                            </div>
                                            
                                        </div>

                                        <div className="flex flex-col">
                                            <div className="xl:w-[265px] md:w-[190px] sm:w-[230px] mt-1"> 
                                            {/* colocar a classe mt na createmodel3 */}
                                                <FormikControl
                                                    control="input"
                                                    label="Assigned Score"
                                                    type="text"
                                                    name="score1_0"
                                            
                                                />
                                            </div>
                                            
                                            <div className="xl:w-[265px] md:w-[190px] sm:w-[230px]">
                                                <FormikControl
                                                    control="input"
                                                    label=""
                                                    type="text"
                                                    name="score2_0"                                       
                                                />
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>    
                                    <span className="flex justify-center mt-20 mb-20">
                                        <button     
                                            type="submit" 
                                            className='bg-indigo-500 hover:bg-indigo-600 text-slate-50 border rounded-md xl:px-5 md:px-2 lg:px-3 xl:py-2 md:w-28 xl:w-[150px] xl:h-[56px] sm:w-28 sm:h-12 sm;text-xs' 
                                            disabled={!formik.isValid}>
                                            Continue
                                        </button>
                                    </span>
                                   
                                </Form>
                            );
                        }}
                    </Formik>  
                </div> 
       </div>
   )

}

export default CreateModelStep3_0;

                   {/* <div className="flex">
                        <div className="flex flex-col mr-4">
                            <div className="xl:w-[265px] md:w-[190px] sm:w-[230px]">
                                <label className="block text-xs sm:text-sm md:text-base font-normal mb-2 mt-8" htmlFor="dropdown2">Variable</label>
                                <CustomSelect 
                                    id={"dropdown3"}
                                    options={options}
                                    onSelect={handleSelectOption}
                                />
                            </div>
                        
                            <div className="mt-5 xl:w-[265px] md:w-[190px] sm:w-[230px]">
                                <CustomSelect 
                                    id={"dropdown3"}
                                    options={options}
                                    onSelect={handleSelectOption1}
                                />
                            </div>
                    
                        </div>
                        <div className="flex flex-col mr-4">
                        
                            <div className="xl:w-[265px] md:w-[190px] sm:w-[230px]">
                                <label className="block text-xs sm:text-sm md:text-base font-normal mb-2 mt-8" htmlFor="dropdown2">Operator</label>
                                <CustomSelect 
                                    id={"dropdown4"}
                                    options={options}
                                    onSelect={handleSelectOption}
                                />
                            </div>
                        
                            <div className="mt-5 xl:w-[265px] md:w-[190px] sm:w-[230px]">
                                <CustomSelect 
                                    id={"dropdown4"}
                                    options={options}
                                    onSelect={handleSelectOption1}
                                />
                            </div>

                        </div> 
                   </div>   */}

                   
        

